import { applyMiddleware, createStore } from 'redux';
import * as _ from 'lodash';
import pixelMiddleware from 'login-middleware/pixelMiddleware';
import createLogger from 'redux-logger';
import ReduxThunk from 'redux-thunk';
import reducer from './reducer';

const logger = createLogger({
  collapsed: true,
  predicate: () => {
    /* istanbul ignore else: (UI-5482) */
    if (_.get(global, 'IS_TEST')) {
      return false;
    }
    /* istanbul ignore next: (UI-5482) */
    const env = window.NODE_ENV;
    /* istanbul ignore next: (UI-5482) */
    return _.includes(['dev', 'sandbox'], env);
  },
});

export default function configureStore(initialState = /* istanbul ignore next: (UI-5482) */ {}) {
  return createStore(reducer, initialState, applyMiddleware(pixelMiddleware, ReduxThunk, logger));
}
